import React from 'react';
import styled from '@emotion/styled';
import { h5Style } from './styles';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const H5Styled = styled.h5`
  ${h5Style};
`;

export default function H5(props: Props) {
  const { children, className } = props;
  return <H5Styled className={className}>{children}</H5Styled>;
}
